var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"view-loyalty__loader"},[_c('ui-loader')],1):_c('div',{staticClass:"layout-level2__container container flow"},[_c('ssm-redemption',{attrs:{"errors":_vm.errors,"read-only":_vm.readOnly}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }